function resolveUrl(value: string | undefined, fallback: string) {
  const next = (value || fallback).trim()
  return next.endsWith('/') ? next : `${next}/`
}

export const WIKI_PUBLIC_URL = resolveUrl(
  import.meta.env.VITE_WIKI_PUBLIC_URL,
  'https://wiki.calamity.online/',
)

export const ARMORY_PUBLIC_URL = resolveUrl(
  import.meta.env.VITE_ARMORY_PUBLIC_URL,
  'https://armory.calamity.online/',
)

export const PLAYER_HUB_URL = resolveUrl(
  import.meta.env.VITE_PLAYER_HUB_URL,
  'https://calamity.online/',
)
